import CSS from './floater.module.css'


export const Floaters = ({ children, flipped }) => {
    return (
        <section className={`${CSS.floaters} block bg-default ${flipped ? CSS.flipped : ''}`}>
            <div className="container maxw-80">
                {children}
            </div>
        </section>
    )
}


export const Floater = ({ children, hero }) => {
    return (
        <section className={CSS.floater}>
            <img className={CSS.blur} src="/assets/theme/blur-01.jpg" alt="" />

            <div className={CSS.container}>
                <div className={CSS.hero}>
                    <img className={CSS.image} src={hero} alt={hero.title}/>               
                </div>

                <div className={`${CSS.content} formatted`}>
                    {children}
                </div>
            </div>
        </section>
    )
}